'use client';

import { useLingui } from '@lingui/react';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Breadcrumbs, {
  BreadcrumbsProps,
  breadcrumbsClasses
} from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { ReactNode } from 'react';

type PageBreadcrumb = {
  label: ReactNode;
  href: string;
};

export type PageBreadcrumbsProps = BreadcrumbsProps & {
  breadcrumbs: PageBreadcrumb[];
};

export function PageBreadcrumbs({
  breadcrumbs = [],
  sx,
  ...breadcrumbProps
}: PageBreadcrumbsProps) {
  const { i18n } = useLingui();
  return (
    breadcrumbs.length > 0 && (
      <Breadcrumbs
        separator={<NavigateNextIcon color="inherit" fontSize="small" />}
        aria-label={i18n.t({
          id: 'common.breadcrumbs',
          message: 'Breadcrumbs'
        })}
        {...breadcrumbProps}
        sx={[
          {
            [`.${breadcrumbsClasses.separator}`]: {
              ml: 0.5,
              mr: 0.5
            }
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
      >
        {breadcrumbs.map(({ label, href }) => (
          <Link color="inherit" variant="body2" href={href} key={href}>
            {label}
          </Link>
        ))}
        <span />
      </Breadcrumbs>
    )
  );
}
